<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>

          <!-- LEFT : DYEING MASTER -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Textile  Info
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense class="mt-3">

                    <v-col cols="12" md="3" sm="6">
                      <v-select
                        label="Buyer Order *"
                        v-model="buyer_order_id"
                        :items="productionOrders"
                        item-title="code"
                        item-value="id"
                        density="compact"
                        variant="outlined"
                        :error="errors.buyer_order_id"
                        :error-messages="errors.buyer_order_id"
                        @update:model-value="onBuyerOrderChange"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-select
                        label="Dyeing Factory *"
                        v-model="dyeing_house_id"
                        :items="customerList"
                        :item-title="item => `${item.customer?.company_name ?? ''} - ${item.customer?.code ?? ''}`"
                        :item-value="item => item.customer?.id ?? null"
                        density="compact"
                        variant="outlined"
                        :error="errors.dyeing_house_id"
                        :error-messages="errors.dyeing_house_id"
                      />
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Order Date"
                        v-model="order_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon="" 
                      />
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Order Receive Date"
                        v-model="order_receive_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon="" 
                      />
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Delivery Date"
                        v-model="delivery_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon="" 
                      />
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-select
                        label="Status *"
                        v-model="dyeing_status"
                        :items="[
                          { title: 'Planned', value: 'planned' },
                          { title: 'Running', value: 'running' },
                          { title: 'Completed', value: 'completed' },
                          { title: 'Rejected', value: 'rejected' },
                        ]"
                        density="compact"
                        variant="outlined"
                        :error="!!errors.dyeing_status"
                        :error-messages="errors.dyeing_status"
                      />
                    </v-col>

                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- RIGHT -->
          <v-col cols="12" md="12" >
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Textile Order Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card flat>
                    <v-card-text >
                      <v-table>
                        <tbody>
                          <tr v-for="(b, i) in breakdowns" :key="i">
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model="b.buyer_order_breakdown.style_code" label="Style" readonly density="compact" hide-details variant="outlined"/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model="b.buyer_order_breakdown.color_name" label="Color" readonly density="compact" hide-details variant="outlined"/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.order_qty_pcs" type="number" label="Order Qty" density="compact" variant="outlined" hide-details hide-spin-buttons readonly/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.req_qty_kg" type="number" label="Req Qty(KG)" density="compact" variant="outlined" hide-details hide-spin-buttons/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model="b.yarn_count" label="Yarn Count*" density="compact" variant="outlined" :error="!!errors[`breakdowns[${i}].yarn_count`]" :error-messages="errors[`breakdowns[${i}].yarn_count`]" hide-details/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.yarn_delivery" type="number" label="Yarn Delivery(KG)" density="compact" variant="outlined" hide-details hide-spin-buttons/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.yarn_receive" type="number" label="Yarn Receive(KG)" density="compact" variant="outlined" hide-details hide-spin-buttons/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.rec_fabric_knit" type="number" label="Rec Fabric Knit(KG)" density="compact" variant="outlined" hide-details hide-spin-buttons/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.dye_delivery" type="number" label="Dye Delivery(KG)" density="compact" variant="outlined" hide-details hide-spin-buttons/>
                            </td>
                            <td class="breakdown-item">
                              <v-text-field class="breakdown-input" v-model.number="b.dye_receive" type="number" label="Dye Receive(KG)" density="compact" variant="outlined" hide-details hide-spin-buttons/>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                      <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>

                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";
import formattedDate from "@/plugins/dateFormatter";

const store = useStore();
const route = useRoute();
const router = useRouter();

const panel = ref([0]);
const panel1 = ref([0]);
const isEdit = ref(false);

const productionOrders = ref([]);
const dyeingHouses = ref([]);
const customerList = ref([]);

const buyer_order_id = ref(null);
const dyeing_house_id = ref(null);
const order_date = ref(null);
const order_receive_date = ref(null);
const delivery_date = ref(null);
const dyeing_status = ref('planned');

const breakdowns = ref([]);
const errors = reactive({});

const dyeingOrderId = route.params.id;

const schema = yup.object({
  buyer_order_id: yup.number().required("Buyer order is required"),
  dyeing_house_id: yup.number().required("Dyeing house is required"),
  breakdowns: yup.array().min(1, "At least one breakdown required"),
  dyeing_status: yup.string().oneOf(["planned", "running", "completed", "rejected"], "Invalid status").required("Dyeing status is required"),
  breakdowns: yup.array().of(
    yup.object({
      yarn_count: yup.string().required("Yarn count is required"),
    })
  ).min(1, "At least one details required"),
});

/* ---------- LOAD ---------- */
async function getInitialData() {
  const [ordersRes, housesRes, customerRes] = await Promise.all([
    store.dispatch("getBuyerOrderList"),
    store.dispatch("getDyeingList"),
    store.dispatch("getCustomerMapList"),
  ]);

  productionOrders.value = ordersRes.data.data;
  dyeingHouses.value = housesRes.data.data;
  customerList.value = customerRes.data.data;

  if (dyeingOrderId) {
    isEdit.value = true;
    loadDyeingOrder();
  }
}

/* ---------- LOAD EDIT DATA ---------- */
async function loadDyeingOrder() {
  const res = await store.dispatch("getDyeingOrderById", { id: dyeingOrderId });
  const d = res.data.data;

  buyer_order_id.value = d.buyer_order_id;
  dyeing_house_id.value = d.dyeing_house_id;
  order_date.value = d.order_date;
  order_receive_date.value = d.order_receive_date;
  delivery_date.value = d.delivery_date;
  dyeing_status.value = d.dyeing_status;
  breakdowns.value = d.breakdowns.map(b => ({
    buyer_order_item_id: b.buyer_order_item_id,
    buyer_order_breakdown: {
      style_code: b.style?.code,
      color_name: b.color?.name,
    },
    style_id: b.style_id,
    color_id: b.color_id,
    order_qty_pcs: b.order_qty_pcs,
    req_qty_kg:  b.req_qty_kg,
    yarn_count: b.yarn_count,
    yarn_delivery: b.yarn_delivery,
    yarn_receive: b.yarn_receive,
    rec_fabric_knit: b.rec_fabric_knit,
    dye_delivery: b.dye_delivery,
    dye_receive: b.dye_receive,
  }));
}

/* ---------- BUYER ORDER CHANGE ---------- */
function onBuyerOrderChange(id) {
  if (isEdit.value) return;

  const order = productionOrders.value.find(o => o.id === id);
  if (!order) return;

  const map = {};

  order.items.forEach(item => {
    item.breakdowns.forEach(b => {
      const key = `${item.id}_${b.color_id}`;
      if (!map[key]) {
        map[key] = {
          buyer_order_item_id: item.id,
          buyer_order_breakdown: {
            style_code: item.style?.code,
            color_name: b.color?.name,
          },
          style_id: item.style_id,
          color_id: b.color_id,
          order_qty_pcs: 0,
          req_qty_kg: 0,
          yarn_count: null,
          yarn_delivery: 0,
          yarn_receive: 0,
          rec_fabric_knit: 0,
          dye_delivery: 0,
          dye_receive: 0,
        };
      }
      map[key].order_qty_pcs += Number(b.quantity || 0);
    });
  });

  breakdowns.value = Object.values(map);
}

/* ---------- SUBMIT ---------- */
async function submitForm(status) {
  const payload = {
    buyer_order_id: buyer_order_id.value,
    dyeing_house_id: dyeing_house_id.value,
    order_date: formattedDate(order_date.value),
    order_receive_date: formattedDate(order_receive_date.value),
    delivery_date: formattedDate(delivery_date.value),
    dyeing_status:dyeing_status.value,
    status,
    breakdowns: breakdowns.value,
  };

    try{
      await schema.validate(payload, { abortEarly: false });
      if (isEdit.value) {
        await store.dispatch("updateDyeingOrder", {id: dyeingOrderId,data: payload});
        toast.success("Updated Successfully");
      } else {
        await store.dispatch("saveDyeingOrder", payload);
        toast.success("Saved Successfully");
      }
    } catch (err) {
      if (err.inner) {
        err.inner.forEach(e => {
          errors[e.path] = e.message;
        });
      }
      return;
    }

  router.push({ name: "textile-order-record" });
}

onMounted(getInitialData);
</script>

<style >
.panel-header {
  background: #eceff1;
  font-weight: 600;
}
.breakdown-item {
  padding: 2px !important;
}
.breakdown-input .v-field__input {
  padding: 1px !important;
  padding-inline: 5px !important;
}
</style>
